export const PenOnDatabaseIcon: React.FC<{ color?: string; style?: React.CSSProperties; className?: string }> = ({
  color,
  style,
  className,
}) => {
  const fill = color || '#1F74B6'

  return (
    <svg
      width='14'
      height='14'
      style={style}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M0.4375 3.06348C0.4375 3.75967 1.1289 4.42735 2.35961 4.91963C3.59032 5.41191 5.25952 5.68848 7 5.68848C8.74048 5.68848 10.4097 5.41191 11.6404 4.91963C12.8711 4.42735 13.5625 3.75967 13.5625 3.06348C13.5625 2.36728 12.8711 1.6996 11.6404 1.20732C10.4097 0.715038 8.74048 0.438477 7 0.438477C5.25952 0.438477 3.59032 0.715038 2.35961 1.20732C1.1289 1.6996 0.4375 2.36728 0.4375 3.06348V3.06348Z'
        stroke={fill}
        strokeWidth='0.95'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.5625 5.25506V3.06348'
        stroke={fill}
        strokeWidth='0.95'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.4375 3.06348V6.56348C0.4375 7.94773 3.11617 9.08114 6.51292 9.18089'
        stroke={fill}
        strokeWidth='0.95'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M0.4375 6.56348V10.0635C0.4375 11.278 2.50017 12.3 5.30075 12.5992'
        stroke={fill}
        strokeWidth='0.95'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M13.2002 8.67442L8.75 13.1253L6.5625 13.5628L7 11.3753L11.4508 6.92384C11.6822 6.69248 11.996 6.5625 12.3232 6.5625C12.6504 6.5625 12.9642 6.69248 13.1956 6.92384L13.2008 6.92909C13.3154 7.0437 13.4063 7.17977 13.4683 7.32953C13.5303 7.47929 13.5622 7.63979 13.5622 7.80188C13.5621 7.96396 13.5301 8.12444 13.468 8.27416C13.4059 8.42387 13.3149 8.55989 13.2002 8.67442V8.67442Z'
        stroke={fill}
        strokeWidth='0.95'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}
